  // Add the theme toggle functionality
  document.querySelectorAll('[data-bs-theme-value]').forEach(button => {
    button.addEventListener('click', () => {
      const theme = button.getAttribute('data-bs-theme-value');
      const themeContainer = document.querySelector('.theme__container');
      if (themeContainer) {
        themeContainer.setAttribute('data-bs-theme', theme);
      }
    });
  });